var _path, _path2, _circle, _circle2, _circle3, _rect, _rect2, _rect3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScoreHuntIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "2 6 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9,26 L9,22 Q9,15 24,15 Q39,15 39,22 L39,26 Z",
    fill: "#B57F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,25 Q12.5,18.5 24,18.5 Q35.5,18.5 35.5,25 Z",
    fill: "#E0A855"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 28,
    r: 4,
    fill: "#FFD54A",
    stroke: "#EBB733",
    strokeWidth: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 28,
    r: 4,
    fill: "#FFD54A",
    stroke: "#EBB733",
    strokeWidth: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 25,
    r: 4.5,
    fill: "#FFD54A",
    stroke: "#EBB733",
    strokeWidth: 0.8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 32,
    height: 4,
    rx: 1.5,
    fill: "#FFC531"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 31,
    width: 30,
    height: 14,
    rx: 2,
    fill: "#A9743A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 35,
    width: 6,
    height: 6,
    rx: 1,
    fill: "#FFC531"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38,
    r: 1.1,
    fill: "#7E4F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreHuntIcon);
export default __webpack_public_path__ + "static/media/score-hunt-icon.c4873915831de0832b70c71d4228aa0b.svg";
export { ForwardRef as ReactComponent };